import { trim } from "lodash-es";
import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const errors = copy.errors;

interface Props {
  setNbRecipients: (value: number) => void;
  setNbExternals: (value: number) => void;
}

export const getFields = ({ setNbRecipients, setNbExternals }: Props): IFormFields => [
  {
    name: "title",
    label: copy.guestlistBlock.email.fields.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
      validate: (value: string) => !!trim(value) || errors.required,
    },
    note: copy.event.email.fields.titleHelp,
  },
  {
    name: "membersToMail",
    label: copy.guestlistBlock.email.fields.members,
    type: IFieldType.peoplePicker,
    onChange: (data: any) => {
      setNbRecipients(data ? data.length : 0);
    },
    note: copy.event.email.fields.membersToMailGuestlistHelp,
  },
  {
    name: "externalsToMail",
    label: copy.guestlistBlock.email.fields.external,
    type: IFieldType.multiCreatableSelect,
    options: [],
    isCreatable: true,
    isMulti: true,
    placeholder: copy.event.email.messages.enterEmails,
    onChange: (data: any) => {
      setNbExternals(data ? data.length : 0);
    },
    note: copy.event.email.fields.externalsToMailHelp,
  },
  {
    name: "intro",
    label: copy.guestlistBlock.email.fields.intro,
    type: IFieldType.rte,
    note: copy.event.email.fields.introHelp,
  },
];
